export const EMERGENCY_CONTACT_NAME_MAX = 100;
export const EMERGENCY_CONTACT_PHONE_MAX = 30;
export const EMERGENCY_CONTACT_UPDATED_EVENT = 'emergencyContactUpdated';
export const EMERGENCY_CONTACT_PHONE_ERROR =
  'Enter a valid phone number (digits, spaces, dashes, parentheses, optional leading +).';

// Mirrors server-side EmergencyContactValidator.
export const isValidEmergencyContactPhone = (phone) => {
  const trimmed = (phone || '').trim();
  if (!trimmed || trimmed.length > EMERGENCY_CONTACT_PHONE_MAX) return false;
  if (!/^\+?[0-9\s\-().]+$/.test(trimmed)) return false;
  const digits = trimmed.replace(/\D/g, '').length;
  return digits >= 7 && digits <= 15;
};

// Optional +1/1 prefix, then 3-3-4 digit groups; anything else (other country codes, extensions) won't match.
const NANP_PHONE = /^(?:\+?1[\s.-]?)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/;

// Display-only: NANP numbers become (613) 864-4631; anything else is shown as entered.
export const formatPhoneForDisplay = (phone) => {
  const trimmed = (phone || '').trim();
  const match = NANP_PHONE.exec(trimmed);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : trimmed;
};

export const hasEmergencyContact = (profile) =>
  !!(profile?.emergencyContactName?.trim() && profile?.emergencyContactPhone?.trim());

export const notifyEmergencyContactUpdated = () => {
  window.dispatchEvent(new Event(EMERGENCY_CONTACT_UPDATED_EVENT));
};
